import { render, staticRenderFns } from "./TeamPanelButton.vue?vue&type=template&id=951b5462&scoped=true&"
import script from "./TeamPanelButton.vue?vue&type=script&lang=js&"
export * from "./TeamPanelButton.vue?vue&type=script&lang=js&"
import style0 from "./TeamPanelButton.vue?vue&type=style&index=0&id=951b5462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951b5462",
  null
  
)

export default component.exports